import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConsultantFinderComponent } from '@consultant/consultant-finder/consultant-finder.component';
import { FindConsultantRequest, LocateConsultantRequest } from '@core/dto/consultant.dto';
import { ConsultantFinderType } from '@core/enums/consultant-finder-type.enum';
import { AppState } from '@core/store';
import { resetFindConsultantState } from '@core/store/consultant/consultant.actions';
import { Store } from '@ngrx/store';
import { isMexEnv } from '@shared/utils/environment-utils';

@Component({
  templateUrl: './consultant-locator-page.component.html',
  styleUrls: ['./consultant-locator-page.component.scss'],
})
export class ConsultantLocatorPageComponent implements OnInit {
  readonly ConsultantFinderType = ConsultantFinderType;
  readonly isMexEnv = isMexEnv;
  finderIsValid: boolean = false;
  filter: FindConsultantRequest | LocateConsultantRequest;
  @ViewChild('consultantFinder') private consultantFinder: ConsultantFinderComponent;

  constructor(
    private store$: Store<AppState>,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.store$.dispatch(resetFindConsultantState());
  }

  onFinderValidChange(valid: boolean) {
    this.finderIsValid = valid;
  }

  onFinderSubmitted(value: FindConsultantRequest | LocateConsultantRequest) {
    this.filter = value;
  }

  search() {
    this.consultantFinder.submit();
  }

  selected() {
    this.router.navigateByUrl('/');
  }
}
